<template>
  <div>
    <div class="downLooad" :ref="$options.name" :class="isClass == 'ios' ? 'QYZXIOS' : 'QYZX'">
      <swiper class="swiper" :options="swiperOption" ref="swiperbox" @slideChange="onSlideChange">
        <!--first screen-->
        <swiper-slide ref="swiperSlide">
          <div v-show="currentSlide == 0" style="height: 100%;">
            <div class="bg1-title">
              <div>
                <img src="https://static.cjlcar.com/xyx/website/logo.png" alt="">
              </div>
              <!-- <div class="bg-phone">
                <p>北京幸运出行科技公司有限公司官网</p>
              </div> -->
            </div>
            <video id="example_video" x5-video-player-fullscreen="true" x5-video-player-type="h5"
              x-webkit-airplay="true" webkit-playsinline="true" playsinline muted preload="auto" poster autoplay loop
              class="video-one">
              <source src="https://static.cjlcar.com/xyx/website/vedio1.mp4" type="video/mp4">
            </video>
            <div id="videoOverlay" @click="togglePlay" class="videoOverlay" v-if="isWXandroid"></div>
            <div class="code-ma">
              <div class="center" @click="dyH5">
                <img src="https://static.cjlcar.com/xyx/website/douyin.png" alt="">
                <p>官方抖音</p>
              </div>
              <div class="center">
                <img src="https://static.cjlcar.com/xyx/website/gongzhonghao.png" alt="">
                <p>官方公众号</p>
              </div>
              <div class="center">
                <img src="https://static.cjlcar.com/xyx/website/weixin.png" alt="">
                <p>官方小程序</p>
              </div>
            </div>
          </div>
        </swiper-slide>
        <!--第二屏-->
        <swiper-slide ref="swiperSlide">
          <div v-show="currentSlide == 1">
            <div class="bg1-title">
              <div>
                <img src="https://static.cjlcar.com/xyx/website/logo.png" alt="">
              </div>
            </div>
            <div class="full-screen-bg2"></div>
          </div>
        </swiper-slide>
        <!--第三屏-->
        <swiper-slide ref="swiperSlide">
          <div v-show="currentSlide == 2">
            <div class="bg1-title">
              <div>
                <img src="https://static.cjlcar.com/xyx/website/logo-lan.png" style="right: 0;" alt="">
              </div>
            </div>
            <div class="full-screen-bg3"></div>
          </div>
        </swiper-slide>
        <!--第四屏-->
        <swiper-slide ref="swiperSlide">
          <div v-show="currentSlide == 3">
            <div class="bg1-title">
              <div>
                <img src="https://static.cjlcar.com/xyx/website/logo-lan.png" style="right: 0;" alt="">
              </div>
            </div>
            <div class="full-screen-bg4"></div>
          </div>
        </swiper-slide>
        <!--第五屏-->
        <swiper-slide ref="swiperSlide">
          <div v-show="currentSlide == 4 && isMobileScreen">
            <div class="full-screen-bg5"></div>
            <div class="bg1-title">
              <img src="https://static.cjlcar.com/xyx/website/logo-lan.png" style="right: 0;" alt="">
            </div>
          </div>
          <div class="full-screen-bg5" v-show="currentSlide == 4 && !isMobileScreen">
            <div class="bg1-title">
              <img src="https://static.cjlcar.com/xyx/website/logo-lan.png" alt="">
            </div>
            <div class="bg-content">
              <div class="bg-content-banner">
                <el-carousel :interval="4000" type="card" height="460px" arrow="always" indicator-position="none">
                  <el-carousel-item v-for="(item, index) in images" :key="index">
                    <img v-lazy="item" style="width: 100%; height: 100%;" />
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </swiper-slide>
        <!--第六屏-->
        <swiper-slide ref="swiperSlide">
          <div v-show="currentSlide == 5">
            <div class="bg1-title">
              <img src="https://static.cjlcar.com/xyx/website/logo.png" alt="">
            </div>
            <div class="full-screen-bg6"></div>
            <div class="goup" @click="homeUp">
              <img src="https://static.cjlcar.com/xyx/website/go_top.png" alt="">
              <p>回到顶部</p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <!--备案号-->
    <div class="page-bottom">
      <p>
        <span>京ICP备2025103731号-1</span>
      </p>
    </div>
    <!--回到首屏箭头-->
    <div v-show="currentSlide != 5" class="swiper-button-next jiantou "></div><!--右箭头。如果放置在swiper外面，需要自定义样式。-->
    <div v-show="currentSlide != 0" class="swiper-button-prev jiantoup "></div>

  </div>

</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'


export default {
  name: "downLooad",
  meta: {
    keywords: "",
    description: "",
  },
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      currentSlide: 0,
      images: [
        'https://static.cjlcar.com/xyx/website/bg5-banner1.jpg',
        "https://static.cjlcar.com/xyx/website/bg5-banner2.jpg",
        "https://static.cjlcar.com/xyx/website/bg5-banner3.jpg",
        "https://static.cjlcar.com/xyx/website/bg5-banner4.jpg",
        "https://static.cjlcar.com/xyx/website/bg5-banner5.jpg",
        "https://static.cjlcar.com/xyx/website/bg5-banner6.jpg"
      ],
      isClass: "", //判断是安卓还是ios
      isMobileScreen: false, //判断是否移动端
      isWXandroid: false,  //判断是否是安卓微信
      swiperOption: {
        effect: 'fade',
        lazy: {
          lazy: true
        },
        direction: 'vertical',
        slidesPerView: 1, // 一屏幕显示多少个slide
        speed: 600, // 控制滑动速度，单位是毫秒
        mousewheel: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
      }
    }
  },

  mounted() {
    this.isMobileScreen = this.isMobile()
    console.log('是否移动端', this.isMobileScreen)
    this.initIntersectionObserver();
    this.isAndroidOrIOS()
  },
  methods: {
    ajaxGet(url, callback, errorCallback) {
      const xhr = new XMLHttpRequest();

      // 初始化请求
      xhr.open('post', url, true);

      // 设置请求完成时的回调
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          // 请求成功
          callback(xhr.responseText);
        } else {
          // 请求失败
          errorCallback(xhr.statusText);
        }
      };

      // 设置请求错误时的回调
      xhr.onerror = function () {
        errorCallback('Network error');
      };

      // 发送请求
      xhr.send();
    },
    dyH5() {
      this.ajaxGet(
        'https://test.cjlcar.com/api/citic-mini/pay-for-H5',
        function (response) {
          console.log('Success:', JSON.parse(response));
           window.location.href = JSON.parse(response).data
        },
        function (error) {
          console.error('Error:', error);
        }
      );
     

    },
    //安卓系统wx浏览器特殊处理
    togglePlay() {
      var video = document.getElementById('example_video')
      var videoOverlay = document.getElementById('videoOverlay')
      video.play()
      videoOverlay.style.display = 'none'
    },
    // 判断是否为移动设备
    isMobile() {
      return (
        typeof window.orientation !== "undefined" || // 判断是否存在window.orientation属性，此属性在移动设备上一般存在
        navigator.userAgent.indexOf('IEMobile') !== -1 || // 判断是否为Windows Phone
        navigator.userAgent.indexOf('iPhone') !== -1 || // 判断是否为iPhone
        navigator.userAgent.indexOf('Android') !== -1 && navigator.userAgent.indexOf('Mobile') !== -1 || // 判断是否为Android手机
        navigator.userAgent.indexOf('BlackBerry') !== -1 || // 判断是否为BlackBerry
        navigator.userAgent.indexOf('Opera Mini') !== -1 // 判断是否为Opera Mini浏览器
      );
    },

    //判断是android还是ios
    isAndroidOrIOS() {
      var u = navigator.userAgent;
      // var ua = navigator.userAgent.toLowerCase();
      var isWx = /micromessenger/i.test(navigator.userAgent); // 是否微信
      var isComWx = /wxwork/i.test(navigator.userAgent); // 是否企业微信
      console.log('u', u)
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        console.log("android>>>>");
        if (isWx && !isComWx) { //android在微信浏览器特殊处理(注意区分企微)
          this.isWXandroid = true
        } else {
          this.isWXandroid = false
        }
        this.isClass = ""
        return this.isClass
      }
      if (isiOS) {
        console.log("ios>>>>");
        if (isWx) { //ios在微信浏览器特殊处理
          // 解决 ios 微信 video 自动播放
          document.addEventListener(
            'WeixinJSBridgeReady',
            function () {
              const video = document.querySelector('video');
              video && video.play();
            },
            false,
          );
        } else {
          this.isClass = "ios"
        }

        return this.isClass
      }

      return false
    },

    //回到首屏
    homeUp() {
      location.reload();
    },
    //监听屏幕变化
    onSlideChange() {
      let el = this.$refs.swiperbox.$swiper;
      console.log('el', el)
      this.currentSlide = el.activeIndex;
    },
    //初始化视口
    initIntersectionObserver() {
      const options = {
        root: null, // 观察根元素，默认为视口
        rootMargin: '0px', // 根元素的边距
        threshold: 0.5 // 元素进入视口的比例阈值
      };

      this.observer = new IntersectionObserver(this.handleIntersection, options);

      // 获取所有 swiper-slide 元素并观察
      if (this.$refs.swiperSlide && Array.isArray(this.$refs.swiperSlide)) {
        this.$refs.swiperSlide.forEach(slide => {

          const _el = slide.$el.querySelector('.main-content-area');
          if (_el) this.observer.observe(_el);
        });
      }
    },
    //销毁动画
    handleIntersection(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate__backInRight', 'visible', 'animate__animated', 'animate__duration-1s');
          // 添加完动画类样式后即销毁监听
          observer.unobserve(entry.target);
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
@import 'swiper/css/swiper.css';
@import 'animate.css';

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 22px;
  /* 调整图标大小 */
}

.video-one {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.page-bottom {
  position: fixed;
  bottom: -6px;
  z-index: 9999;
  left: 10px;
  color: #555;
}

.jiantou {
  position: absolute;
  top: 96%;
  left: 50%;
  transform: translateX(-50%)rotate(90deg);
  animation: toggleMove .8s infinite;
}

.jiantoup {
  position: absolute;
  top: 4%;
  left: 50%;
  transform: translateX(-50%)rotate(90deg);
  animation: toggleMovep .8s infinite;
}

@keyframes toggleMovep {
  0% {
    top: 3%;
    opacity: .3;
  }

  50% {
    top: 2%;
    opacity: 1;
  }

  100% {
    top: 3%;
    opacity: .3;
  }
}

@keyframes toggleMove {
  0% {
    top: 97%;
    opacity: .3;
  }

  50% {
    top: 98%;
    opacity: 1;
  }

  100% {
    top: 97%;
    opacity: .3;
  }
}

.bg1-title {
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;

  img {
    width: 66px;
    height: 66px;
    position: absolute;
    top: -15px;
  }
}

.bg1-title-One {
  height: 66px;
  display: flex;
  position: absolute;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  top: -6px;

  img {
    width: 66px;
    height: 66px;
  }

  .bg-phone {
    color: white;
    font-size: 16px;
    font-weight: 600;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

.videoOverlay {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 9999;
  background-image: url('https://static.cjlcar.com/xyx/website/bofang.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 88px;
  height: 88px;
  transform: translate(-50%, -50%);
}

@media screen and (max-width: 996px) {
  .QYZXIOS {
    height: calc(100vh - 75px) !important;

    .full-screen-bg2 {
      height: calc(100vh - 75px) !important;
    }

    .full-screen-bg3 {
      height: calc(100vh - 75px) !important;
    }

    .full-screen-bg4 {
      height: calc(100vh - 75px) !important;
    }

    .full-screen-bg5 {
      height: calc(100vh - 75px) !important;
    }

    .full-screen-bg6 {
      height: calc(100vh - 75px) !important;
    }
  }

  .goup {
    display: none;
  }

  .code-ma {
    position: absolute;
    bottom: 0px;
    right: 0;
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: end;
    justify-content: space-between;

    .center {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: white;

      p {
        margin-top: 2px;
      }
    }

    img {
      width: 66px;
      height: 66px;
    }
  }

  .downLooad {
    height: 100vh;
    overflow: initial;
    display: flex;
    width: 100%;

    .swiper {
      height: 100%;
      width: 100%;

      .content-body {
        background: linear-gradient(180deg, rgba(255, 119, 119, 0.08) 0%, rgba(241, 164, 86, 0.08) 32%, #FDEFEF 100%);
        height: 100%;
        width: 100%;

        .main-content-area {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 48px;
          opacity: 0;

          &.visible {
            opacity: 1;
          }
        }

        &.v-bg2 {
          background: linear-gradient(180deg, #FFEBEB 0%, #FDF1E6 32%, #F9DDDF 100%);
        }
      }

      .full-screen-bg2 {
        background-image: url('https://static.cjlcar.com/xyx/website/mobile-image2.jpg');
        display: flex;
        width: 100vw;
        height: 100vh;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        /* 背景图片固定在视图中 */
        background-attachment: fixed;
      }

      .full-screen-bg3 {
        background-image: url('https://static.cjlcar.com/xyx/website/mobile-image3.png');
        display: flex;
        width: 100vw;
        height: 100vh;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        /* 背景图片固定在视图中 */
        background-attachment: fixed;
      }

      .full-screen-bg4 {
        background-image: url('https://static.cjlcar.com/xyx/website/mobile-image4.jpg');
        display: flex;
        width: 100vw;
        height: 100vh;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        /* 背景图片固定在视图中 */
        background-attachment: fixed;
      }

      .full-screen-bg5 {
        background-image: url('https://static.cjlcar.com/xyx/website/mobile-image5.png');
        display: flex;
        width: 100vw;
        height: 100vh;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        /* 背景图片固定在视图中 */
        background-attachment: fixed;
      }

      .full-screen-bg6 {
        background-image: url('https://static.cjlcar.com/xyx/website/mobile-image6.jpg');
        display: flex;
        width: 100vw;
        height: 100vh;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        /* 背景图片固定在视图中 */
        background-attachment: fixed;
      }

    }
  }

}

@media screen and (min-width: 997px) {
  .goup {
    position: absolute;
    right: 8px;
    bottom: 16px;
    color: #ccc;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    img {
      width: 36px;
      height: 56px;
    }

    p {
      margin: 0 !important;
    }
  }


  .code-ma {
    position: absolute;
    bottom: 0px;
    right: 0;
    width: 420px;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .center {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: white;

      p {
        font-size: 14px;
      }
    }

    img {
      width: 100px;
      height: 100px;
    }
  }

  .downLooad {
    height: 100vh;
    overflow: initial;
    display: flex;
    width: 100%;

    .swiper {
      height: 100%;
      width: 100%;

      .content-body {
        background: linear-gradient(180deg, rgba(255, 119, 119, 0.08) 0%, rgba(241, 164, 86, 0.08) 32%, #FDEFEF 100%);
        height: 100%;
        width: 100%;

        .main-content-area {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 48px;
          opacity: 0;

          &.visible {
            opacity: 1;
          }
        }

        &.v-bg2 {
          background: linear-gradient(180deg, #FFEBEB 0%, #FDF1E6 32%, #F9DDDF 100%);
        }
      }

      .full-screen-bg2 {
        display: flex;
        width: 100vw;
        height: 100vh;
        background-image: url('https://static.cjlcar.com/xyx/website/image2.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        /* 背景图片固定在视图中 */
        background-attachment: fixed;
      }

      .full-screen-bg3 {
        display: flex;
        width: 100vw;
        height: 100vh;
        background-image: url('https://static.cjlcar.com/xyx/website/image3.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        /* 背景图片固定在视图中 */
        background-attachment: fixed;
      }

      .full-screen-bg4 {
        display: flex;
        width: 100vw;
        height: 100vh;
        background-image: url('https://static.cjlcar.com/xyx/website/image4.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        /* 背景图片固定在视图中 */
        background-attachment: fixed;
      }

      .full-screen-bg5 {
        width: 100%;
        height: 100%;

        .bg-content {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          margin: 0 80px;

          .bg-content-title {
            position: absolute;
            left: 80px;
            top: 140px;
          }

          .bg-content-banner {
            width: 100%;

            .el-carousel__item: nth-child(2n) {
              background-color: #99a9bf;
            }

            .el-carousel__item:nth-child(2n+1) {
              background-color: #d3dce6;
            }
          }
        }
      }

      .full-screen-bg6 {
        display: flex;
        width: 100vw;
        height: 100vh;
        background-image: url('https://static.cjlcar.com/xyx/website/image6.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        /* 背景图片固定在视图中 */
        background-attachment: fixed;
      }
    }
  }


}
</style>
